import {
  MAKE_MODEL_YEAR, MAKE_YEAR_MODEL, YEAR_MAKE_MODEL, YEAR_MAKE_MODEL_ENGINE,
} from "../../component/vehicle-form/constants";

export function getVehicleSelectionOrder(make: string, model: string, year: string, businessCustomer = false) {
  if (businessCustomer) {
    return YEAR_MAKE_MODEL_ENGINE;
  }
  if (make && model && !year) {
    return MAKE_MODEL_YEAR;
  }
  if (make && !model && !year) { // https://dev.partsavatar.ca/cv-boot?make=HONDA
    return MAKE_YEAR_MODEL;
  }
  return YEAR_MAKE_MODEL;
}
